import React, {Component} from 'react';
import './Dropdown.css';
// import Portal from './Portal'; NOTE -- Uncomment to use globally positioned dropdown

class Dropdown extends Component {
	constructor(props) {
		super(props);

		this.state = {
			shown: props.initiallyShown || false,
			valueBuffer: props.value,
			left: 0,
			top: 0,
			highlighted: null,
			filteredItems: null
		};

		this.show = () => {
			if (this.props.scrollInOnShow) {
				// Hack for iOS -- ensure maximum input+dropdown visibility
				document.activeElement.scrollIntoView({behavior: 'smooth'});
			}
			// this.updatePosition(); NOTE -- Uncomment to use globally positioned dropdown
			this.setState({shown: true, filteredItems: false});
		};

		this.hide = () => {
			this.setState({shown: false});
		};

		this.onSelect = highlighted => {
			this.props.onSelect && this.props.onSelect(highlighted);
			this.setState({shown: false});
		};

		this.clickOut = e => {
			if (
				this.el &&
				e.target !== this.input &&
				!this.el.contains(e.target) &&
				this.el !== e.target
			) {
				this.setState({shown: false, valueBuffer: this.props.value});
				if (this.props.onBlur) this.props.onBlur();
			}
		};

		this.updateBuffer = e => {
			const valueBuffer = e.target.value;
			let filteredItems = null;
			if (valueBuffer !== this.props.value) {
				const bufUpper = valueBuffer.toUpperCase();

				// Cache filtered items for perf
				filteredItems = this.props.items.filter(
					item =>
						item.label.toUpperCase().indexOf(bufUpper) >= 0 ||
						('' + item.extra).toUpperCase().indexOf(bufUpper) >= 0
				);
			}
			this.setState({valueBuffer, filteredItems});
		};

		this.updatePosition = () => {
			const rect = this.el.getBoundingClientRect();
			const pageOffset = {x: window.pageXOffset, y: window.pageYOffset};
			const top = pageOffset.y + rect.top + rect.height;
			const left = pageOffset.x + rect.left;

			if (top !== this.state.top || left !== this.state.left) {
				this.setState({left, top});
			}
		};

		this.onScroll = e => {
			if (this.el) {
				window.requestAnimationFrame(this.updatePosition);
			}
		};

		this.itemOver = value => {
			this.setState({highlighted: value});
		};

		this.itemOut = value => {
			if (this.state.highlighted === value) {
				this.setState({highlighted: null});
			}
		};

		this.handleKeyPress = e => {
			if ((e.key === 'Enter' || e.key === 'Tab') && this.state.highlighted) {
				if (this.props.onSelect) this.props.onSelect(this.state.highlighted);
				this.hide();
			} else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
				if (this.state.shown) {
					let highlighted;
					let change = e.key === 'ArrowDown' ? 1 : -1;
					let items = this.state.filteredItems || this.props.items;

					e.preventDefault(); // Prevent arrow navigation within input

					if (this.state.highlighted) {
						let currentIndex = items.findIndex(item => item.value === this.state.highlighted);
						currentIndex += change;
						currentIndex =
							currentIndex >= items.length ? 0 : currentIndex < 0 ? items.length - 1 : currentIndex;
						highlighted = items[currentIndex] || null;
						highlighted = highlighted && highlighted.value;
					} else {
						highlighted = items[0] || null;
						highlighted = highlighted && highlighted.value;
					}

					this.setState({highlighted});
				} else {
					this.show();
				}
			}
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.props.value) {
			// Buffer always overridden by prop value
			this.setState({
				valueBuffer: nextProps.value || null,
				filteredItems: null
			});
		}
	}

	componentDidMount() {
		document.body.addEventListener('click', this.clickOut);
		// window.addEventListener('scroll', this.onScroll); NOTE -- Uncomment to use globally positioned dropdown
		if (this.props.initiallyShown) {
			this.input.focus();
			this.input.select();
			// this.updatePosition(); NOTE -- Uncomment to use globally positioned dropdown
		}
	}

	componentWillUnmount() {
		document.body.removeEventListener('click', this.clickOut);
		// window.removeEventListener('scroll', this.onScroll); NOTE -- Uncomment to use globally positioned dropdown
	}

	render() {
		const {className, value, extra, allowNull = false, items = []} = this.props;
		const {shown, valueBuffer, left, top, filteredItems, highlighted} = this.state;

		return (
			<div
				className={`Dropdown ${className || ''} ${shown ? 'shown' : ''}`}
				ref={el => (this.el = el)}>
				<div className="Dropdown-selection" tabIndex={1}>
					<input
						className="Dropdown-input"
						value={valueBuffer || ''}
						onChange={this.updateBuffer}
						onKeyDown={this.handleKeyPress}
						ref={el => (this.input = el)}
						onFocus={this.show}
						onBlur={this.hide}
					/>
					{extra && <div className="Dropdown-extra">{extra}</div>}
				</div>
				{/*NOTE -- Change to <Portal /> to use globally positioned dropdown*/}
				<div className={`Dropdown-wrapper ${shown ? 'shown' : ''}`}>
					{/*style={{left, top}} add to use globally positioned dropdown*/}
					<ol className="Dropdown-values">
						{allowNull && (
							<DropdownItem
								key={'null'}
								isHighlighted={!highlighted}
								onClick={this.onSelect}
								onMouseOver={this.itemOver}
								onMouseOut={this.itemOut}
								value={null}
								label="(No selection)"
							/>
						)}
						{(filteredItems || items).map(item => (
							<DropdownItem
								key={item.value}
								isHighlighted={highlighted === item.value}
								onClick={this.onSelect}
								onMouseOver={this.itemOver}
								onMouseOut={this.itemOut}
								{...item}
							/>
						))}
						{!(filteredItems || items).length && (
							<div className="Dropdown-empty">No items found</div>
						)}
					</ol>
				</div>
			</div>
		);
	}
}

class DropdownItem extends Component {
	constructor() {
		super();
		this.handleClick = () => {
			if (this.props.onClick) this.props.onClick(this.props.value);
		};
		this.mouseOver = () => this.props.onMouseOver(this.props.value);
		this.mouseOut = () => this.props.onMouseOut(this.props.value);
	}

	render() {
		const {label, extra, isHighlighted} = this.props;

		return (
			<li
				className={`Dropdown-item ${isHighlighted ? 'highlighted' : ''}`}
				onMouseDown={this.handleClick}
				onMouseOver={this.mouseOver}
				onMouseOut={this.mouseOut}>
				<div className="Dropdown-name">{label}</div>
				<div className="Dropdown-extra">{extra}</div>
			</li>
		);
	}
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/widgets/Dropdown.js